<ngxh6-toast-container></ngxh6-toast-container>
@if (user.watch | async; as _user) {
    @if (!hideNavbar) {
        @if (padContent) {
            <app-navbar></app-navbar>
        } @else {
            <app-crm-navbar></app-crm-navbar>
        }
    }
    <!-- A Business Login holder can reach the public site - it is where Apply for a permit
     lives - and the only route back was buried in the profile dropdown. This says where
     they are and gives them the door. -->
    @if (businessUserOnPublicSite) {
        <div class="business-area-banner">
            <div class="inner">
                <span><i class="fa fa-circle-info me-2"></i>You're on the public site. Permits you issue for your organisation are in the business area.</span>
                <a class="btn btn-sm btn-light ms-3 text-nowrap" routerLink="/business"> <i class="fa fa-briefcase me-1"></i>Business area </a>
            </div>
        </div>
    }

    <div class="app-content" [class.has-navbar]="padContent" [class.has-business-banner]="businessUserOnPublicSite">
        <router-outlet></router-outlet>
    </div>
    @if (showRequests) {
        <ngxh6-requests class="lower-position"></ngxh6-requests>
    }
    @if (!online) {
        <div class="offline-banner">
            <div class="inner">{{ user.simulating_offline ? '(Simulating) ' : '' }}Offline - Features may be unavailable</div>
        </div>
    }
}
